import { render, staticRenderFns } from "./AppReportGuestAvatarMenu.vue?vue&type=template&id=e97f503a&scoped=true"
import script from "./AppReportGuestAvatarMenu.vue?vue&type=script&lang=js"
export * from "./AppReportGuestAvatarMenu.vue?vue&type=script&lang=js"
import style0 from "./AppReportGuestAvatarMenu.vue?vue&type=style&index=0&id=e97f503a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97f503a",
  null
  
)

export default component.exports